<template>
  <CategoryLayout
    type="author"
    :category-info="author"
    :label="label"
    :searcher="customSearcher"
    :show-categories="true"
    :show-nav-bar="showNavBar"
    show-extra
    :sort-strategy="sortStrategy"
    :publications="authorBooks"
    :custom-back-to="toPrevRouteLink"
    :custom-counter="customCounter"
    :show-author-link="false"
    @change="filterChanged"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import SessionStorageService from '@/services/SessionStorageService';

import libraryViewScrollMixin from '@/components/mixins/libraryViewScrollMixin';

import CategoryLayout from '@/components/views/CategoryView/CategoryLayout.vue';

export default {
  name: 'AuthorView',
  components: {
    CategoryLayout
  },
  mixins: [libraryViewScrollMixin],
  props: {
    author: Object,
    publications: Array,
    searcher: Object,
    sortStrategy: String,
    customCounter: [Number, String]
  },
  data() {
    return {
      customSearcher: this.searcher
    };
  },
  computed: {
    ...mapGetters('LibraryStore', ['searchPublications']),
    toPrevRouteLink() {
      const prevRoute = this.$store.state.ContextStore.previousNotAuthorRoute;
      const storedPrevRoute = SessionStorageService.get('previousRoute');

      let actualPrevRoute;
      if (prevRoute?.name) {
        actualPrevRoute = prevRoute;
      } else if (storedPrevRoute?.name) {
        actualPrevRoute = storedPrevRoute;
      }
      return actualPrevRoute;
    },
    label() {
      return this.author?.name ?? '';
    },
    authorBooks() {
      if (!this.customSearcher && !this.publications) {
        return [];
      }
      if (this.publications && this.searcher === this.customSearcher) {
        return this.publications;
      }
      return this.searchPublications(this.customSearcher);
    },
    showNavBar() {
      return (
        (this.author?.FAQ && this.author.FAQ.length > 0) || !!this.author?.BIO
      );
    }
  },
  destroyed() {
    SessionStorageService.set(
      'previousRoute',
      this.$store.state.ContextStore.previousNotAuthorRoute
    );
  },
  methods: {
    filterChanged(searcher) {
      this.customSearcher = searcher;
      this.$store.commit('LibraryStore/setAuthorSearcher', searcher);
    }
  }
};
</script>

<style lang="less"></style>
